/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nutrition_NoneInputs */

const en_nutrition_none = /** @type {(inputs: Nutrition_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No nutrition yet: match the ingredients first.`)
};

const de_nutrition_none = /** @type {(inputs: Nutrition_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Nährwerte: ordne zuerst die Zutaten zu.`)
};

/**
* | output |
* | --- |
* | "No nutrition yet: match the ingredients first." |
*
* @param {Nutrition_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrition_none = /** @type {((inputs?: Nutrition_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrition_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrition_none(inputs)
	return en_nutrition_none(inputs)
});